import { Link, Text, useTheme } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getSupportPhone } from '../../../../../constants/supportPhone'
import { Scope } from '../../../../../enums/scope'
import { isAuthorized } from '../../../../../utils/isAuthorized'
import * as Styled from './styles'

export const HelpModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const {
    ds: { data },
  } = useTheme()

  const { email } = data.menu.help
  const { number: phone } = getSupportPhone(organization?.countryId)
  const isPhoneNumberVisible = isAuthorized([Scope.SupportPhoneNumberRead])

  return (
    <Styled.FooterWrapper>
      <Text colorVariant="secondary" variant="bodySM">
        {t('help.modal.footer.cannot_find')}
      </Text>
      <Styled.Info>
        {isPhoneNumberVisible && (
          <Styled.FooterContactItem>
            <Text variant="bodySM" colorVariant="secondary">
              {t('help.modal.footer.call_us')}
              :&nbsp;
            </Text>
            <Text variant="bodySM">
              <Link href={`tel:${phone}`} target="_blank" rel="noopener noreferrer">
                {phone}
              </Link>
            </Text>
          </Styled.FooterContactItem>
        )}
        <Styled.FooterContactItem>
          <Text variant="bodySM" colorVariant="secondary">
            {t('help.modal.footer.mail_us')}
            :&nbsp;
          </Text>
          <Text variant="bodySM">
            <Link href={`mailto:${email}`} rel="noopener noreferrer" target="_blank">
              {email}
            </Link>
          </Text>
        </Styled.FooterContactItem>
      </Styled.Info>
    </Styled.FooterWrapper>
  )
}
